import { createSlice } from '@reduxjs/toolkit';

import { getReminderById, updateReminder } from './action';
import IUpdateReminderState from './model';

const initialState: IUpdateReminderState = {
  updateReminderState: {
    loading: false,
    isSuccess: false,
  },
  reminder: {
    data: null,
    loading: false,
  },
};

export const updateRemindersSlice = createSlice({
  name: 'reminder/UpdateReminder',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(updateReminder.pending, (state) => {
        state.updateReminderState.loading = true;
      })
      .addCase(updateReminder.fulfilled, (state, action) => {
        state.updateReminderState.loading = false;
        if (action.payload && action.payload.status === 200) {
          state.updateReminderState.isSuccess = true;
        }
      })
      .addCase(updateReminder.rejected, (state) => {
        state.updateReminderState.loading = false;
      });

    builder
      .addCase(getReminderById.pending, (state) => {
        state.reminder.loading = true;
      })
      .addCase(getReminderById.fulfilled, (state, action) => {
        state.reminder.loading = false;
        state.reminder.data = action.payload;
      })
      .addCase(getReminderById.rejected, (state) => {
        state.reminder.loading = false;
      });
  },
});

export default updateRemindersSlice.reducer;
